import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "btn-all-works" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "btn-all-works-desktop" }, "Все работы", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "btn-all-works-mobile" }, "Все", -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "m-pageCW-map-menu js-swiper-bigGallery" }
const _hoisted_6 = { class: "swiper-wrapper" }
const _hoisted_7 = { class: "swiper-slide" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"m-pageCW-map-menu-buttons\"><div class=\"swiper-button-next\"><svg width=\"9\" height=\"16\" viewBox=\"0 0 9 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.25312 15.7396C-0.0843725 15.3925 -0.0843724 14.8297 0.253121 14.4826L6.55566 8L0.253122 1.51743C-0.0843712 1.17029 -0.0843712 0.607482 0.253122 0.260348C0.590614 -0.0867851 1.1378 -0.0867851 1.47529 0.260348L9 8L1.47529 15.7396C1.1378 16.0868 0.590612 16.0868 0.25312 15.7396Z\" fill=\"#54BC00\"></path></svg></div><div class=\"swiper-button-prev\"></div></div>", 1)
const _hoisted_12 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalWork = _resolveComponent("ModalWork")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['m-pageCW-map', {'m-pageCW-map--fullScreen': _ctx.isFullScreenMap}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['m-pageCW-map-menu-wrapper', {'m-pageCW-map-menu-wrapper--fullScreen': _ctx.isFullScreenMap}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass([{'active': !_ctx.currentItemMenu}]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedItemMenu()))
        }, _hoisted_4, 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBuildForMenu(), (category) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(['m-pageCW-map-menu__item', {'active': _ctx.currentItemMenu === category.id}]),
                onClick: ($event: any) => (_ctx.selectedItemMenu(category.id))
              }, [
                (category.svgContent)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      innerHTML: `${category.svgContent} <span>${category.name}</span>`
                    }, null, 8 /* PROPS */, _hoisted_9))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      innerHTML: `<img src='${category.imgContent}' alt='#'/> <span>${category.name}</span>`
                    }, null, 8 /* PROPS */, _hoisted_10))
              ], 10 /* CLASS, PROPS */, _hoisted_8)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ]),
      _hoisted_11
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      id: _ctx.id,
      style: _normalizeStyle(_ctx.style),
      class: "m-pageCW-map-container"
    }, null, 12 /* STYLE, PROPS */, _hoisted_12),
    (_ctx.isShowSelectedWork)
      ? (_openBlock(), _createBlock(_component_ModalWork, {
          key: 0,
          onShowSelectedWork: _ctx.onShowSelectedWork,
          "is-full-screen-map": _ctx.isFullScreenMap
        }, null, 8 /* PROPS */, ["onShowSelectedWork", "is-full-screen-map"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}